import React, { Component } from "react";
import { connect } from "react-redux";
import MenuLeftItem from "./MenuLeftItem";
import AuthRender from "../../containers/AuthRender";
import { currentClientSelector } from "../../redux/selectors/auth";
// Components

const mapStateToProps = (state, ownProps) => {
  return {
    menuData: state.app.menuLeftContent,
    client: currentClientSelector(state)
  };
};

class MenuLeft extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { menuData, currentClient, userInfos } = this.props;
    let menuLeftItems =
      menuData && menuData.contentType === "menu"
        ? menuData.content
            //.filter(v => v.id !== "merch" || (v.id === "merch" && this.props.client.id === 1)) //ASAHI ONLY
            .map((data, m) => {
              return (
                <AuthRender key={m} service={data.service} minRole={data.minRole} roles={data.roles}>
                  <MenuLeftItem key={m} menuData={data} currentClient={currentClient} userInfos={userInfos} />
                </AuthRender>
              );
            })
        : null;

    return menuData.display ? (
      menuData.contentType == "menu" ? (
        <nav className={`p-menu-second-sub ${/*menuData.classes*/ "" || ""}`}>{menuLeftItems}</nav>
      ) : (
        <nav className={`p-menu-second-sub ${this.props.stats ? "stats" : ""}`}>{menuData.content}</nav>
      )
    ) : null;
  }
}

export default connect(mapStateToProps, null)(MenuLeft);



// WEBPACK FOOTER //
// src/components/menu/MenuLeft.js